import React from 'react';

const Select = (props) => (
    <div className="form-group">
        <label>{props.label}</label>
        <select
            className={props._className}
            placeholder={props.placeholder}
            value={props.value}
            onChange={props.onChange}
            readOnly = {props.readOnly}
            defaultValue = {props.defaultValue}
        >
            {props.list.map((item, i) =>
                props.selectType === 'obj' ?
                <option 
                key={i} 
                value={item[props.optionValue]} 
                disabled = {item[props.optionValue] === 0 }
                >{item[props.optionLabel]}</option>
                :
                <option key={i}>{item}</option>
            )}
        </select>
        {props.error &&
            <div className="invalid-feedback">
               Le champ { props.label} est obligatoire
             </div>
        }
    </div>
)

export default Select;


// WEBPACK FOOTER //
// ./src/components/Common/Select.js